import '../../00group-input/dees-input-multitoggle/dees-input-multitoggle.js';
import { DeesElement, customElement, html, state, cssManager } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import { healthScenarios, operationStatus, operationsDemoStyles, type TDemoHealth } from '../../../demos/operations.js';
import { themeDefaultStyles } from '../../00theme.js';
import '../../00group-button/dees-button/dees-button.js';
import '../../00group-utility/dees-icon/dees-icon.js';

@customElement('dees-demo-service-health')
class DeesDemoServiceHealth extends DeesElement {
  @state() private accessor scenario: TDemoHealth = 'degraded';
  @state() private accessor step = 0;
  @state() private accessor sampledAt = Date.now();
  @state() private accessor message = 'Each check explains its status. Use Copy options to take a detail with you.';
  @state() private accessor showEmpty = false;
  public static styles = [themeDefaultStyles, cssManager.defaultStyles, operationsDemoStyles];

  private choose(scenario: TDemoHealth) {
    this.scenario = scenario; this.step = 0; this.sampledAt = Date.now();
    this.message = `${healthScenarios.find((entry) => entry.key === scenario)!.label} scenario loaded.`;
  }

  public render() {
    return html`
      <div class="toolbar">
        <dees-input-multitoggle label="Service scenario" .labelPosition=${'none'}
          .options=${healthScenarios.map(item => ({ key: item.key, label: item.label }))} .selectedOption=${this.scenario}
          @change=${(event: CustomEvent) => this.choose(event.detail.value)}></dees-input-multitoggle>
        <dees-button type="ghost" text="Reset checks" @clicked=${() => this.choose('degraded')}></dees-button>
      </div>
      <dees-dataview-statusobject .statusObject=${operationStatus(this.scenario, this.step, this.sampledAt)}></dees-dataview-statusobject>
      <div class="foot"><p class="feedback" role="status">${this.message}</p>
        <dees-button type="outline" text="Run checks" icon="lucide:RefreshCw" @clicked=${() => {
          this.step++; this.sampledAt = Date.now(); this.message = `Check ${this.step + 1} completed. The latest results are shown above.`;
        }}></dees-button></div>
      <details @toggle=${(event: Event) => { this.showEmpty = (event.currentTarget as HTMLDetailsElement).open; }}>
        <summary><dees-icon icon="lucide:ChevronRight" iconSize="16" aria-hidden="true"></dees-icon>Before a service reports</summary>
        ${this.showEmpty ? html`<div class="examples"><p class="caption">Missing data stays distinct from a healthy result.</p><dees-dataview-statusobject></dees-dataview-statusobject></div>` : ''}
      </details>`;
  }
}

export const demoFunc = () => demoPage('Service health', 'See what needs attention, understand each check, and copy the details you need.', html`<dees-demo-service-health></dees-demo-service-health>`);
